import { render, staticRenderFns } from "./DaysOfWeek.vue?vue&type=template&id=0a6d42ca&scoped=true"
import script from "./DaysOfWeek.vue?vue&type=script&lang=js"
export * from "./DaysOfWeek.vue?vue&type=script&lang=js"
import style0 from "./DaysOfWeek.vue?vue&type=style&index=0&id=0a6d42ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6d42ca",
  null
  
)

export default component.exports